module.exports = __webpack_public_path__ + "static/media/layer_2.3f6f56d2.svg";